import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import { deleteSchoolWeek, getCurrentSchoolWeek, setPage } from '../../actions/schoolWeeks'
import Table from '../../components/Table'
import Select from '../../components/Select'
import { getSchoolYears } from '../../actions/common'
import { getStudyPeriod } from '../../actions/classbook'
import Confirmation from '../../components/Confirmation/Confirmation'
import { BiTrash } from 'react-icons/bi'
import { getScheduleVariantsDO } from '../../actions/doScheduleVariants'
import { getScheduleVariantsVD } from '../../actions/vdScheduleVariants'
import { getCurrentYearUtils } from '../../utils/classBook'
import { getScheduleVariantsList } from '../../actions/scheduleVariants'
import SelectModal from './SelectModal/SelectModal'

import moment from 'moment'
import { getLibraryWeeks } from '../../actions/library'



export default function SchoolWeeks() {

  const dispatch = useDispatch()

  const { schoolYears, } = useSelector(state => state.common)
  const { currentWeek } = useSelector(state => state.school_weeks)
  const { weeks } = useSelector(state => state.library)
  const { studyPeriod } = useSelector(state => state.classbook)
  const { list: do_sh } = useSelector(state => state.do_schedule_variants)
  console.log('do_sh::: ', do_sh);
  const { list: vd_sh } = useSelector(state => state.vd_schedule_variants)
  console.log('vd_sh::: ', vd_sh);
  const { list: reg_sh } = useSelector(state => state.schedule_variants)

  const highLow = weeks ? [...weeks].sort((a, b) => b.week_id - a.week_id) : undefined

  const [selectedItem, setSelectedItem] = useState(null)
  const [filteredWeek, setFilteredWeek] = useState(null)
  const [weekForDelete, setWeekForDelete] = useState(null)
  const [sh, setSh] = useState(null)
  const [openSelectModal, setOpenSelectModal] = useState(false)
  const [selectedWeekVariant, setSelectedWeekVariant] = useState([])



  const [formData, setFormData] = useState({
    scYear: 0,
    studyPeriod: 'all',
  })


  useEffect(() => {
    dispatch(getSchoolYears())
  }, [])

  useEffect(() => {
    const currYear = getCurrentYearUtils(schoolYears, moment().format('YYYY.MM.DD'))
    setFormData({ ...formData, scYear: currYear })
  }, [schoolYears])

  useEffect(() => {
    formData.scYear &&
      dispatch(getStudyPeriod(formData))
  }, [formData.scYear])

  useEffect(() => () => dispatch(setPage(0)), [])
  useEffect(() => {
    if (selectedWeekVariant.length) {
      const a = sh == 'sh' ? 'pers_sh_var_id' : sh == 'sh_vd' ? 'out_sh_var_id' : 'do_sh_var_id'
      const r = highLow?.filter(el => el[a] === selectedWeekVariant[0]?.sh_var_id)
      setFilteredWeek(r)
    }
  }, [selectedWeekVariant])

  const fetchWeeks = () => {
    if (!formData.scYear) return
    const hasPeriod = formData.studyPeriod && formData.studyPeriod !== 'all'
    dispatch(getLibraryWeeks(hasPeriod ? { school_year: formData.scYear, trmid: formData.studyPeriod } : { school_year: formData.scYear }))
  }

  useEffect(() => {
    if (studyPeriod && formData.scYear) {
      fetchWeeks()
      // dispatch(getScheduleVariantsDO(formData.scYear))
      // dispatch(getScheduleVariantsVD(formData.scYear))
      // dispatch(getScheduleVariantsList(formData.scYear))
    }
  }, [formData])


  const openModal = (data) => () => {
    if (data?.week_id) dispatch(getCurrentSchoolWeek(data.week_id))
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const renderOptions = ({ name, title, xp_key, trmid }) => <option key={trmid || xp_key} value={trmid || xp_key}>{name || title}</option>

  const deleteClickHandler = (wid) => (e) => {
    e.stopPropagation()
    setWeekForDelete(wid)
  }

  const acceptConfirm = async () => {
    await dispatch(deleteSchoolWeek(weekForDelete.id, formData))
    fetchWeeks()
    setWeekForDelete(null)
  }

  const rejectConfirm = () => {
    setWeekForDelete(null)
  }

  const renderLi = (data) => {
    const { week_id, week_name, wstart_date, wend_date, week_comment, do_sh_var_id, out_sh_var_id, pers_sh_var_id } = data
    const sch = reg_sh?.find(el => el.sh_var_id === pers_sh_var_id)?.sh_var_name
    const sch_do = do_sh?.find(el => el.sh_var_id === do_sh_var_id)?.sh_var_name
    const sch_vd = vd_sh?.find(el => el.sh_var_id === out_sh_var_id)?.sh_var_name

    return (
      <tr onClick={openModal(data)}>
        <td>{week_name}</td>
        <td>{wstart_date}</td>
        <td>{wend_date}</td>
        <td>{week_comment}</td>
        <td>{sch}</td>
        <td>{sch_do}</td>
        <td>{sch_vd}</td>
        <td><i className={styles.trash} onClick={deleteClickHandler({ id: week_id, name: week_name })}><BiTrash /></i></td>
      </tr>
    )
  }

  const openSelect = (item) => () => {
    setOpenSelectModal(item)
    setSh(item)
  }
  const closeSelect = () => {
    setOpenSelectModal(false)
  }

  const handleChangeStudents = (weekVariant) => {
    setSelectedWeekVariant([weekVariant])
    closeSelect()
    // if (typeof weekVariant === 'number') setSelectedWeekVariant((prev) => prev.filter(el => el.mid !== weekVariant))
    // else setSelectedWeekVariant((prev) => !prev.find(el => el.sh_var_id === weekVariant.sh_var_id) ? [...prev, weekVariant] : prev.toSpliced(prev.indexOf(weekVariant), 1))
  }

  return (
    <div className={styles.wrapper}>
      {weekForDelete &&
        <Confirmation
          title={`Вы уверены что хотите удалить неделю ${weekForDelete.name}?`}
          acceptConfirmation={acceptConfirm}
          rejectConfirmation={rejectConfirm}
        />
      }
      <Modal
        closeModal={closeModal}
        data={selectedItem}
        currentWeek={currentWeek}
        handleInputChange={handleInputChange}
        renderOptions={renderOptions}
        params={formData}
        onSuccess={fetchWeeks}
      />
      {openSelectModal &&
        <SelectModal
          closeModal={closeSelect}
          data={openSelectModal}
          height={'430px'}
          handleChangeStudents={handleChangeStudents}
          selectedWeekVariant={selectedWeekVariant}
        />
      }

      <h1>Недели</h1>

      <div className={styles.selects}>
        <Select
          title="Год"
          name={"scYear"}
          options={schoolYears}
          value={formData?.scYear}
          withoutArrowMode
          onChange={handleInputChange}

        />

        <Select
          title="Учебный период"
          name={"studyPeriod"}
          options={[{ name: 'Все', value: 'all' }, ...(studyPeriod || [])]}
          value={formData?.studyPeriod}
          withoutArrowMode
          onChange={handleInputChange}

        />
      </div>

      <Table style={{ marginTop: '2rem', backgroundColor: 'white' }}>
        <thead>
          <tr>
            <th>Название</th>
            <th>Начало</th>
            <th>Окончание</th>
            <th>Примечание</th>
            <th onClick={openSelect('sh')}>Вариант расписания</th>
            <th onClick={openSelect('sh_do')}>Вариант расписания ДО</th>
            <th onClick={openSelect('sh_vd')}>Вариант расписания ВД</th>
          </tr>
        </thead>
        <tbody style={{ backgroundColor: 'white' }}>

          {(filteredWeek || highLow)?.map(renderLi)}

        </tbody>
      </Table>

      <Button
        style={{ padding: '.5rem 1.5rem' }}
        onClick={openModal()}
      >
        <IoIosAdd size={30} />
        Добавить неделю
      </Button>
    </div>
  )
}